<ng-template #unhandledError>
	<div class="container-fluid">
		<div class="row padding-top-10">
			<div class="col-xs-12">
				<div class="centered-copy">
					<div class="alert alert-danger">
						{{ 'UnhandledError' | translate }}
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<div [ngClass]="[styles.producerVideoControls, controlsRow ? styles.toolbarRow : styles.toolbarCol ]" *ngIf="!error; else unhandledError">

	<div [ngClass]="styles.playerRow" *ngIf="!controlsOnly">
		<div [ngClass]="styles.playerWrap" [vbWatchDimensions]="[captureWrap]" [padding]="5" *ngIf="streams.displayCaptureStream">
			<div #captureWrap [ngClass]="[styles.playerWrapInner, styles.left]">
				<video autoplay [muted]="true" vbDraggable [dragData]="getCaptureDragData" [dragOptions]="dragOptions" [dragEnabled]="canEditLayout" [srcObject]="streams.displayCaptureStream">
				</video>
				<span *ngIf="showLabel" [ngClass]="styles.label">
					{{ 'Event_Producer_MyScreenLabel' | translate }}
				</span>

				<div [class]="styles.dropdown" dropdown vbDropdown container="body" *ngIf="canEditLayout">
					<button type="button" dropdownToggle [class]="styles.dropdownToggle">
						<i class="glyphicons more"></i>
					</button>
					<div *dropdownMenu [ngClass]="styles.dropdownMenu" class="dropdown-menu dropdown-menu-right">
						<button type="button" class="dropdown-item" *ngIf="layoutTypes.content; else addContentMenu" (click)="removePresenter(StreamType.Content)">
							{{ (layoutTypes.contentBg ? 'Event_Producer_PresenterRemoveBgScreen' : 'Event_Producer_PresenterRemoveScreen') | translate }}
						</button>
						<ng-template #addContentMenu>
							<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Content)">
								{{ 'Event_Producer_PresenterAddScreen' | translate }}
							</button>
							<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Content, true)">
								{{ 'Event_Producer_PresenterAddScreenBg' | translate }}
							</button>
						</ng-template>
					</div>
				</div>
			</div>
		</div>

		<div [ngClass]="styles.playerWrap" [vbWatchDimensions]="[cameraWrap]" [padding]="5">

			<div #cameraWrap [ngClass]="[
				styles.playerWrapInner,
				streams.displayCaptureStream ? styles.right : styles.center
			]">
				<div [ngClass]="styles.placeholder" *ngIf="!streams.cameraOutputStream$; else cameraVideo">
					<img [attr.src]="'/img/placeholder-2.svg'" alt=""/>
				</div>
				<span *ngIf="showLabel" [ngClass]="styles.label">
					{{ canEditLayout ? ('Event_Producer_ProducerLabel' | translate: { '0': userName }) : isExternal ? ('Event_Producer_ExternalLabel' | translate: { '0': userName }) : userName }}
				</span>
				<div [class]="styles.dropdown" dropdown vbDropdown container="body" *ngIf="canEditLayout && (cameraEnabled || streams.micStream)">
					<button type="button" dropdownToggle [class]="styles.dropdownToggle">
						<i class="glyphicons more"></i>
					</button>
					<div *dropdownMenu [ngClass]="styles.dropdownMenu" class="dropdown-menu dropdown-menu-right">
						<ng-container *ngIf="cameraEnabled || layoutTypes.speaker">
							<button type="button" class="dropdown-item" *ngIf="layoutTypes.speaker; else addSpeakerMenu" (click)="removePresenter(StreamType.Speaker)">
								{{ (layoutTypes.speakerBg ? 'Event_Producer_PresenterRemoveBgCamera' : 'Event_Producer_PresenterRemoveCamera') | translate }}
							</button>

							<ng-template #addSpeakerMenu>
								<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Speaker)">
									{{ 'Event_Producer_PresenterAddCamera' | translate }}
								</button>
								<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Speaker, true)">
									{{ 'Event_Producer_PresenterAddCameraBg' | translate }}
								</button>
							</ng-template>
						</ng-container>
						<button type="button" class="dropdown-item" *ngIf="!!streams.micStream && !layoutTypes.speaker && !layoutTypes.content" (click)="toggleLayoutAudio()">
							{{ (layoutTypes.audio ? 'Event_Producer_PresenterRemoveAudio' : 'Event_Producer_PresenterAddAudio') | translate }}
						</button>
					</div>
				</div>


				<div *ngIf="hasMicStream" [ngClass]="[styles.audioStatus, isSpeaking ? styles.speakingStatus : streams.micMuted ? styles.muteStatus : '']">
					<span class="vb-icon" [ngClass]="streams.micMuted ? 'vb-icon-mic-off' : 'vb-icon-mic-on'"></span>
				</div>
			</div>
		</div>
	</div>

	<ng-template #cameraVideo>
		<video autoplay [muted]="true" vbDraggable [dragData]="getCameraDragData" [dragOptions]="dragOptions" [dragEnabled]="canEditLayout" [srcObject]="streams.cameraOutputStream$ | async">
		</video>
	</ng-template>

	<div [ngClass]="styles.toolbar">
		<div [ngClass]="styles.toolbarGroup" dropdown vbDropdown #shareDropdown="bs-dropdown" [dropup]="true">
			<button type="button" (click)="toggleCapture()" [disabled]="captureProcessing" [ngClass]="streams.displayCaptureStream ? styles.btnActive2 : ''" [attr.aria-label]="(streams.displayCaptureStream ? 'Event_Capture_ChangeScreen' : 'Event_Capture_ShareScreen') | translate">
				<span class="vb-icon vb-icon-share"></span>
			</button>

			<button type="button" [ngClass]="styles.toolbarMenuBtn" dropdownToggle>
				<span class="vb-icon vb-icon-chevron" [ngClass]="!controlsRow ? styles.chevronRight : ''"></span>
			</button>

			<div *dropdownMenu class="dropdown-menu" role="menu">
				<button type="button" role="menuitem" class="list-group-item dropdown-item" (click)="startCapture()">
					{{ (streams.displayCaptureStream ? 'Event_Capture_ChangeScreen' : 'Event_Capture_ShareScreen') | translate }}
				</button>
				<button type="button" *ngIf="streams.displayCaptureStream" role="menuitem" class="list-group-item dropdown-item" [disabled]="captureProcessing" (click)="stopCapture()" [attr.aria-label]="'Event_Capture_StopShare' | translate">
					{{ 'Event_Capture_StopShare' | translate }}
				</button>
			</div>
		</div>

		<div [ngClass]="styles.toolbarGroup" dropdown vbDropdown #camDropdown="bs-dropdown" [dropup]="true">
			<button type="button" [ngClass]="cameraEnabled ? styles.btnActive : styles.btnInactive" [disabled]="cameraProcessing" (click)="setCamera(!cameraEnabled, streams.cameraDevice)" [attr.aria-label]="(cameraEnabled ? 'Event_SelfProduced_StopCam' : 'Event_SelfProduced_StartCam') | translate">
				<span class="vb-icon" [ngClass]="cameraEnabled ? 'vb-icon-camera' : 'vb-icon-camera-off'"></span>
			</button>

			<button type="button" [ngClass]="styles.toolbarMenuBtn" dropdownToggle [disabled]="cameraProcessing">
				<span class="vb-icon vb-icon-chevron" [ngClass]="!controlsRow ? styles.chevronRight : ''"></span>
				<span class="visually-hidden">{{'Event_SelfProduced_ChooseCam' | translate}}</span>
			</button>

			<div *dropdownMenu class="dropdown-menu" role="menu">
				<button type="button" *ngIf="cameraEnabled" role="menuitem" class="list-group-item dropdown-item" (click)="setCamera(false)">
					{{'Event_SelfProduced_StopCam' | translate}}
				</button>
				<button type="button" role="menuitem" class="list-group-item dropdown-item" (click)="setCamera(true)">
					{{'Capture_ChooseCameraAutomatically' | translate}}
				</button>
				<button type="button" role="menuitem" class="list-group-item dropdown-item" [ngClass]="styles.menuItem" (click)="setCamera(true, device)" *ngFor="let device of streams.cameraDevices">
					{{ device.label }}
					<span *ngIf="streams.cameraLabel === device.label" class="vb-icon vb-icon-round-check"></span>
				</button>
				<span *ngIf="!streams.cameraDevices.length" class="list-group-item dropdown-item">
					{{'Event_Producer_NoCamera' | translate}}
				</span>
			</div>
		</div>

		<div [ngClass]="styles.toolbarGroup" dropdown vbDropdown #micDropdown="bs-dropdown" [dropup]="true">
			<button type="button" [ngClass]="streams.micStream && !streams.micMuted ? styles.btnActive : styles.btnInactive" [disabled]="micProcessing" (click)="toggleMic()" [attr.aria-label]="(!streams.micStream
					? 'Event_SelfProduced_StartMic'
					: streams.micMuted ? 'Event_SelfProduced_Unmute' : 'Event_SelfProduced_Mute') | translate">
				<span class="vb-icon" [ngClass]="streams.micStream && !streams.micMuted ? 'vb-icon-mic-on' : 'vb-icon-mic-off'"></span>
			</button>

			<button type="button" dropdownToggle [ngClass]="styles.toolbarMenuBtn" [disabled]="micProcessing">
				<span class="vb-icon vb-icon-chevron" [ngClass]="!controlsRow ? styles.chevronRight : ''"></span>
				<span class="visually-hidden">{{'Event_SelfProduced_ChooseMic' | translate}}</span>
			</button>

			<div *dropdownMenu class="dropdown-menu" role="menu">

				<button type="button" *ngIf="streams.micStream" role="menuitem" class="list-group-item dropdown-item" (click)="toggleMic()">
					{{(streams.micMuted ? 'Event_SelfProduced_Unmute' : 'Event_SelfProduced_Mute') | translate}}
				</button>
				<button type="button" role="menuitem" class="list-group-item dropdown-item" (click)="setMic(true)">
					{{'Capture_ChooseMicAutomatically' | translate}}
				</button>
				<button type="button" role="menuitem" class="list-group-item dropdown-item" [ngClass]="styles.menuItem" (click)="setMic(true, device)" *ngFor="let device of streams.micDevices">
					{{ device.label }}
					<span *ngIf="streams.micLabel === device.label" class="vb-icon vb-icon-round-check"></span>
				</button>
				<span *ngIf="!streams.micDevices.length" class="list-group-item dropdown-item">
					{{'Event_Producer_NoMic' | translate}}
				</span>
			</div>
		</div>
	</div>
</div>
